import { Observable } from "rxjs"
import LabPanel from "./RandomsModel/LabPanel"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function LabPanelsGetObservable(link: string, labAccount: string, vendorID: number): Observable<LabPanel[]> {
  const params: string = JSON.stringify({
    Link: link,
    IsDOT: false,
    IsMarketPlace: true,
    IsPoct: false,
    LabAccountNumber: labAccount,
    VendorID: vendorID
  })

  return ObservableFromFetch<LabPanel[]>("FFOrderPoolDefinition/GetPoolDefinitionLabPanels", params)
}
